<template>
    <el-container class="is-vertical" style="flex-shrink: 0">
        <el-main class="stats-viewer">
            <div class="headings">
                <h2>Stats viewer</h2>
            </div>
            <div class="filters-row">
                <div class="filter-label">Entity type:</div>
                <el-radio-group v-model="type">
                    <el-radio-button label="tour">COOBO</el-radio-button>
                    <el-radio-button label="asset">ASSETS</el-radio-button>
                </el-radio-group>
            </div>
            <div class="filters-row">
                <div class="filter-label">Search by:</div>
                <el-radio-group v-model="searchBy">
                    <el-radio-button label="createdAt">Created</el-radio-button>
                    <el-radio-button label="updatedAt">Updated</el-radio-button>
                </el-radio-group>
            </div>
            <div class="filters-row">
                <div class="filter-label">Search by:</div>
                <el-date-picker
                        v-model="dateRange"
                        :picker-options="getPickerOptions()"
                        unlink-panels
                        type="daterange"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date">
                </el-date-picker>
            </div>
            <div class="filters-row">
                <el-button type="success" class="has-shadow" :disabled="!dateRange" @click="getData">SEARCH</el-button>
                <el-button type="success" class="has-shadow" :disabled="!tableData.length" @click="exportExcel">Export</el-button>
            </div>
            <el-table
                ref="singleTable"
                v-if="tableData.length"
                class="stats-table"
                id="outTable"
                show-summary
                :data="tableData"
                highlight-current-row
                style="width: 100%">
            <el-table-column v-for="(column, index) in tableColumns"
                sortable
                v-bind:fixed = "index == 0 ? true: false"
                v-bind:min-width = "150"
                v-bind:key="column.id"
                v-bind:property="column.id"
                v-bind:label="column.title">
            </el-table-column>
        </el-table>

        </el-main>
    </el-container>
</template>

<script>
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';

    export default {
        name: 'statsViewer',
        data() {
            return {
                searchBy: "createdAt",
                type: "tour",
                palettes: [],
                dateRange: '',
                data: [],
                weeks: [],

                tableData:[],
                tableColumns:[]

            }
        },
        mounted() {
            // if (this.$store.state.user.role.name !== "Administrator") {
            //     this.$router.push("/my-library")
            // }
            // this.axios.get(this.$store.state.API_URL + 'colorpalettes').then((response) => {
            //     this.palettes = response.data;
            // })

        },
        methods: {
            getPickerOptions() {
                return {
                    disabledDate: (date) => date > new Date()
                }
            },
            getData() {
                let from = this.dateRange[0];
                let to = this.dateRange[1];
                if (to > new Date())
                    to = new Date();
                this.axios.post(`${this.$store.state.API_URL}get-${this.type}-stats`,
                    {
                        from: this.dateRange[0],
                        to: this.dateRange[1],
                        searchBy: this.searchBy,
                    }).then((response) => {
                    this.tableData=[];
                    this.tableColumns=[];
                    
                    this.data = Object.keys(response.data).reduce((acc,user) => acc.concat([{user: user, items: response.data[user]}]), [])
                    let weeks = [];
                    let weekStart = new Date(from);
                    while (weekStart < to) {
                        let weekEnd = new Date(weekStart.getTime() + 24*60*60*1000*(6 - weekStart.getDay()));
                        weekEnd.setHours(23);
                        weekEnd.setMinutes(59);
                        weekEnd.setSeconds(59);
                        let week = {from: weekStart, to: weekEnd >= to ? to : weekEnd};
                        weeks.push(week);
                        weekStart = new Date(week.to.getTime() + 24*60*60*1000);
                        weekStart.setHours(0);
                        weekStart.setMinutes(0);
                        weekStart.setSeconds(0);
                    }
                    this.weeks = weeks.reverse();
                    

                    let columns = this.weeks.map((item)=>{
                        return {
                            title: `${item.from.toLocaleDateString()}-${item.to.toLocaleDateString()}`,
                            id: `${new Date(item.from).getTime()}`,
                        }
                    })
                    this.tableColumns = [{title:'User', id:'userName'}, ...columns]

                    for (let user of this.data) {
                        let objdata = {userName:user.user}

                        for(let week of this.weeks) {
                            let value = user.items.filter(item => new Date(item[this.searchBy]) >= week.from && new Date(item[this.searchBy]) <= week.to).length
                            objdata[`${new Date(week.from).getTime()}`] = value
                        }
                        this.tableData.push(objdata);
                    }
                })
            },
            exportExcel() {
                let xlsxParam = { raw: true };// When converting to excel, use the original format
                let wb = XLSX.utils.table_to_book(document.querySelector("#outTable"),xlsxParam);//outTable is the list id

                var wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array"
                });
                try {
                    FileSaver.saveAs(
                    new Blob([wbout], { type: "application/octet-stream;charset=utf-8" }),
                    "sheetjs.xlsx"
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, wbout);
                }
                return wbout;
        },

        },
        components: {}
    }
    function getWeek(date) {

    }
</script>



// WEBPACK FOOTER //
// src/pages/StatsViewer.vue